export default [
    {
        path: "TemplateManage",
        name: "TemplateManage",
        meta: {
          title: "活动模板"
        },
        component: () =>
          import("@/views/Home/ReferralManagement/TemplateManage/index")
      },
      {
        path: "TagLibrary",
        name: "TagLibrary",
        meta: {
          title: "标签库管理"
        },
        component: () =>
          import("@/views/Home/ReferralManagement/TagLibrary/index")
      },
      {
        path: "Gallery",
        name: "Gallery",
        meta: {
          title: "校区助手素材库"
        },
        component: () =>
          import("@/views/Home/ReferralManagement/Gallery/index")
      },
]